/* globals showModalInfo */
import React, { useContext, useState, useEffect } from "react";
import styled from "styled-components";
import Radio from "common/Radio.jsx";
import SettingsView, { NoContextMenu } from "common/SettingsView";
import { composeApplyCommand, checkWarnings } from "./api";
import requestUserFile from "../ProvideFile";
import ActionsContext from "common/ActionsContext";
import { requestMoment } from "views/Status/Billing/api";
import { YYYYMMDDHHmmssSSS } from "common/utils";

const strategyOptions = [
  { value: "restore", label: "Restore backup." },
  { value: "merge", label: "Merge backup." },
];

const Interactive = styled.div`
  & > * {
    margin: 0.25em 1em;
  }
`;

const StrategyOption = styled.div`
  label {
    font-size: 12px !important;
    padding-right: 20px;
  }
`;

const WarningsWrapper = styled.div`
  margin-top: 20px;

    ul {
    list-style: none;
      padding: 0;
    }
  `;


const Warnings = ({ strategy }) => (
  <WarningsWrapper>
    WARNING:
    <ul>
      {strategy !== "restore" ? null : (
        <li>
          The current subscriber id's, subscriber-groups, and policies assigned
          or defined via Radius/REST/Billing will be replaced by those in the
          backup file.
        </li>
      )}
      {strategy !== "merge" ? null : (
        <li>
          To the current subscriber id's, subscriber-groups, and policies
          assigned or defined via Radius/REST/Billing, we will add those
          in the backup file.
        </li>
      )}
    </ul>
  </WarningsWrapper>
);

const LoadSettings = ({ state, onChange }) => {
  return (
  <>
    <Interactive>
      <Radio
        options={strategyOptions}
        name="strategy"
        defaultValue={state.strategy}
        itemWrapper={StrategyOption}
        onChange={onChange}
      />
    </Interactive>
    <Warnings strategy={state.strategy} />
  </>
)};

const reportSuccess = () =>
  showModalInfo("Success", "Subscriber attributes file loaded successfully");

const TMP_CONF_PATH = "/tmp/reload_attributes_";
const createFilePath = () => TMP_CONF_PATH + YYYYMMDDHHmmssSSS(new Date());

const saveToCLI = (filepath, contents) =>
  ifCl.transfer(contents, filepath)
    .catch((error, reason) => {
      throw `Error uploading subscriber attributes file: ${reason}`;
    });

const provideFile = () =>
  requestUserFile().then((contents) => saveToCLI(createFilePath(), contents));

const LoadSubsAttributes = ({ defaults = {} }) => {
  const actions = useContext(ActionsContext);
  const [isBusy, setBusy] = useState(false);

  const notifyAndRevert = (error) => {
    error = error.message === undefined ? new Error(error) : error;
    throw error;
  };

  const markAsBusy = (response) => setBusy(true) || response;

  const markAsReady = (response) => setBusy(false) || response;

  const submitCommand = (command) =>
    ifCl.run(command, /*is batch*/ false);

  const apply = (settings, originalSettings = {}) => {
    const buildCommand = (filePath) =>
      composeApplyCommand({ filePath, strategy: settings.strategy });

    return provideFile()
      .then(markAsBusy)
      .then((filePath) => buildCommand(filePath))
      .then(submitCommand)
      .then(checkWarnings)
      .then(reportSuccess)
      .catch(notifyAndRevert)
      .finally(markAsReady);
  };
  const load = () =>
    requestMoment().then((moment) => ({
      ...defaults,
      moment,
      strategy: "restore",
      file: "",
      pristine: false,
    }));
  return (
    <SettingsView
      load={load}
      apply={apply}
      applyLabel={isBusy !== true ? "SELECT FILE" : "APPLYING..."}
      ContextMenu={NoContextMenu}
      noDiscard={true}
      title="Load Backup of External Attributes and Subscriber Groups"
      applyActionClassName="hidden-to-operators"
      PendingChangesIndicator={null}
      subtitle={<small>Loading may take some time.</small>}
      id="viewBackupLoadSubsAttributes"
    >
      <LoadSettings />
    </SettingsView>
  );
};

export default LoadSubsAttributes;
